const routes = {
  index: {
    path: 'index.consult.area',
    url: '/zones',
  },
  home: {
    path: 'index.consult.area.home',
    url: '/accueil',
  },
  new: {
    path: 'index.consult.area.new',
    url: '/creer',
  },
  edit: {
    path: 'index.consult.area.edit',
    url: '/modifier',
  },
  details: {
    path: 'index.consult.area.details',
    url: '/details',
  },
}

export default routes



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/area/routes.js